<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Meta Data"
            bc3="Update"
            path="card-meta-data"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="name"
                                  class="form-control"

                                  name="name"
                                  placeholder="Name"

                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Alias</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="alias"
                                  class="form-control"
                                  name="alias"
                                  placeholder="Alias"
                              />

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="type">
                                <option value="">Select Type</option>
                                <option :value="item.id" v-for="(item) in chargeTypeOption">
                                  {{item.name}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Status</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="status">
                                <option :value="1">Active</option>
                                <option :value="0">Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$emit('back')"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {
  mounted() {
    this.getChargesTypes()
    let chargesUpdateData = this.$store.getters.getByKey("metaDataUpdate");
    this.index = chargesUpdateData.index;
    this.id = chargesUpdateData.row.id;
    this.name = chargesUpdateData.title
    this.type = chargesUpdateData.type.id;
    this.alias = chargesUpdateData.alias;
    this.status = chargesUpdateData.status;
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      alias: "",
      type: "",
      status: 1,
      loading: false,
      size: "10px",
      types: ['BRANDS','CATEGORY','TYPE','INDUSTRY','TIERS','COUNTRY'],
      chargeTypeOption: [],
      chargeTypeDetailOptions: [],
    };
  },
  methods: {
    getChargesTypes(){
      this.makeRequest("post", "v1/get-charges-types-data", {cardMetaDataTypes: 1}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.chargeTypeOption = data.cardMetaDataTypes
                }

              }
            }
          }
      );
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          let data = {
            id: this.id,
            name : this.name,
            type : this.type,
            alias : this.alias,
            status : this.status
          }

          this.makeRequest("post", "v1/update-card-meta-data", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("metaDataUpdate");
                    let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                    let rowProp = {
                      ...storeData,
                      ...responseData
                    }
                    rawdata[storeData.idx] = rowProp
                    this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                    this.$emit('back')
                    return
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  },
};
</script>

